import { useApp } from "../context/useApp"
import { DEFAULT_DIALOG_HANDLE, ROUTES } from "../utils/symbols"
import { _ } from "../utils/helpers"

type DaultDialogName = 'no-tables' | 'no-tables-after-payment'

export const useDefaultDialogs = () => {

    const {
        state: { dialogHandles, booking },
        actions: { navigate }
    } = useApp()

    const dialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    function show(name: DaultDialogName) {

        switch (name) {
            case 'no-tables':
                dialogHandle.openDialog({
                    dialog: 'error',
                    className: 'error w-100 h-100 df aic jcc',
                    title: _('5ci_oopst__'),
                    message: _('5ci_plsea__'),
                    button: _('0ge_gobac__'),
                    callback: () => {
                        booking.unselectShift().render()
                        navigate(ROUTES.TABLE_LAYOUT)
                        dialogHandle.closeDialog()
                    },
                })
                break;
            case 'no-tables-after-payment':
                dialogHandle.openDialog({
                    dialog: 'error',
                    className: 'error w-100 h-100 df aic jcc',
                    title: _('0er_yourr__', booking.locator),
                    message: _('0er_someo__'),
                    contactUs: true,
                    contactUsByEmail: true,
                    callback: () => {
                        booking.unselectShift().render()
                        navigate(ROUTES.TABLE_LAYOUT)
                        dialogHandle.closeDialog()
                    },
                })
                break;
        }
    }

    return { show }
}